import FamilyFocusedCard from "./FamilyFocusedCard";
import guidedFamily from "../../assets/guided-family.svg";
import researchBased from "../../assets/research-based.svg";
import cultureAwareness from "../../assets/culture-awareness.svg";
import { useTranslation } from "react-i18next";
import { useLocal } from "hooks/useLocal";

export function FamilyFocused() {
  const { t } = useTranslation(["common"]);
  const { direction, isArabic } = useLocal();
  const dirAttr: string | undefined = Array.isArray(direction)
    ? direction[0]
    : direction;
  return (
    <section
      dir={dirAttr}
      className={`bg-[#F8F8F8] ${isArabic ? "font-ibmplex" : "font-inter"}`}
    >
      <article className="py-20 px-6 max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="flex flex-col items-center justify-center gap-2">
          <p
            className={`text-[16px] text-center font-bold text-[#4242CE] ${isArabic ? "font-ibmplex" : "font-funnel"}`}
          >
            {t("familyFocused.whyNumuw")}
          </p>
          <div className={`bg-[#4242CE] h-[2px] w-20 mt-1`}></div>
        </div>

        <p
          className={`text-center text-2xl md:text-[32px] font-bold text-gray leading-[39px] mt-4 ${isArabic ? "font-ibmplex" : "font-funnel"}`}
        >
          {t("familyFocused.regionOnlyFamilyFocused")}
        </p>

        {/* Cards */}
        <section className="mt-10 flex flex-col md:flex-row gap-6 justify-between items-center">
          <FamilyFocusedCard
            imageSrc={guidedFamily}
            title={t("familyFocused.guidedFamilyTitle")}
            description={t("familyFocused.guidedFamilyDescription")}
            direction={dirAttr}
          />
          <FamilyFocusedCard
            imageSrc={researchBased}
            title={t("familyFocused.researchBasedTitle")}
            description={t("familyFocused.researchBasedDescription")}
            direction={dirAttr}
          />
          <FamilyFocusedCard
            imageSrc={cultureAwareness}
            title={t("familyFocused.cultureAwarenessTitle")}
            description={t("familyFocused.cultureAwarenessDescription")}
            direction={dirAttr}
          />
        </section>
      </article>
    </section>
  );
}
